import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/** Request body for POST `/api/v1/submissions/query` (camelCase). */
export interface SubmissionsQueryPayload {
  accountantId: string;
  companyId?: string | null;
  clientType?: string | null;
  status?: string | null;
  rangeFrom?: string | null;
  rangeTo?: string | null;
}

/** Row from pm-api (camelCase JSON). */
export interface SubmissionsRowApi {
  id: string;
  name?: string | null;
  type?: number | null;
  companyType?: string | null;
  clientId?: string | null;
  ctCount?: number | null;
  apCount?: number | null;
  sa100Count?: number | null;
  sa800Count?: number | null;
  sa900Count?: number | null;
  bkVatCount?: number | null;
  bkCisCount?: number | null;
  prP11DCount?: number | null;
  prP9DCount?: number | null;
  prP46Count?: number | null;
  prPrfpsCount?: number | null;
  prEpsCount?: number | null;
  prEyusCount?: number | null;
  totalCount?: number | null;
}

export interface SubmissionsQueryResponseApi {
  items: SubmissionsRowApi[];
  totalCount: number;
}

@Injectable({ providedIn: 'root' })
export class PmSubmissionsApiService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.pmApiBaseUrl;

  querySubmissions(payload: SubmissionsQueryPayload): Observable<SubmissionsQueryResponseApi> {
    const root = this.base?.replace(/\/$/, '') ?? '';
    return this.http.post<SubmissionsQueryResponseApi>(`${root}/api/v1/submissions/query`, payload);
  }
}
